window.bundleapp = window.bundleapp || {};
window.bundleapp.settings = Object.assign({}, window.bundleapp.settings || {}, {
  bab: {
    productImage: 600,
    addToCartRedirect: ({ cartItems, discountCode }) => {
      const openCartEvent = new Event("reloadCartAndOpen", { cartItems, discountCode });
      window.dispatchEvent(openCartEvent);
      localStorage.setItem("openCart", "1");
      window.location.assign(`/discount/${discountCode}?redirect=/`);
    }
  }
});

const waitForElement = (selector, callback, delay = 0, failsafeDelay) => {
  const observer = new MutationObserver((mutations, obs) => {
    const element = document.querySelector(selector);
    if (element) {
      obs.disconnect();
      if (typeof callback === "function") {
        setTimeout(() => {
          callback(element);
        }, delay);
      }
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  if (failsafeDelay) setTimeout(() => observer.disconnect(), failsafeDelay);
};

//if awtomic customer portal
if (window.location.pathname.includes("/tools/bundle-subscriptions") && window.location.search.includes("subscriptionId=")) {
  document.body.classList.add("awt-cp");

  //disable skip and nbd edit if user skips (enabled after next billing)
  const skipApiPattern = /https:\/\/shapi\.bundlepayments\.com\/customers\/\d+\/subscriptions\/\d+\/skip/;

  if (window.fetch) {
    const originalFetch = window.fetch;
    window.fetch = (...args) => {
      const url = typeof args[0] === "string" ? args[0] : args[0]?.url || "";

      return originalFetch(...args).then((response) => {
        if (skipApiPattern.test(url) && response.ok) {
          document.body.classList.add("hideSkipAndNBD");
        }
        return response;
      });
    };
  }

  const checkSkippedAttribute = () => {
    const customAttributes = window.Awtomic?.subscriptionDetails?.CustomAttributes;
    if (customAttributes) {
      const skippedAttr = customAttributes.find((attr) => attr.key === "skipped" && attr.value === "true");
      if (skippedAttr) {
        document.body.classList.add("hideSkipAndNBD");
      }
    }
  };

  window.addEventListener("awtomic-cp-loaded", () => {
    if (window.Awtomic && window.Awtomic.subscriptionDetails) {
      const options = {
        weekday: "long",
        day: "numeric",
        month: "long",
        year: "numeric"
      };
      const formatter = new Intl.DateTimeFormat("en-NZ", options);
      const formattedBillingDate = formatter.format(new Date(window.Awtomic.subscriptionDetails.NextBillingDate));

      const handleDeliveryDateUI = () => {
        const title = document.querySelector(".bundle-details-table-title");
        if (title && !document.querySelector(".delivery-date-container")) {
          const yourNextOrder = document.querySelector(".bundle-details-table-title");
          const yourBillingDate = document.querySelector(".bundle-card--next-order-date .bundle-card__body div span:first-child");

          // For the next order date
          if (yourNextOrder) {
            let nextOrderDate = yourNextOrder?.innerText?.split("•")[1]?.trim();
            if (nextOrderDate) {
              const dateParts = nextOrderDate.split("/");
              if (dateParts.length === 3) {
                const formattedDate = `${dateParts[1]}/${dateParts[0]}/${dateParts[2]}`;
                yourNextOrder.innerHTML = `Your next order • ${formattedDate}`;
              }
            }
          }

          // For the billing date
          if (yourBillingDate) {
            // Format billing date to dd/mm/yyyy
            const billingDateParts = formattedBillingDate.match(/(\d+)\s+(\w+)\s+(\d+)/);
            if (billingDateParts) {
              const day = billingDateParts[1].padStart(2, "0");
              const monthName = billingDateParts[2];
              const year = billingDateParts[3];
              const monthNumber = new Date(`${monthName} 1, ${year}`).getMonth() + 1;
              const month = monthNumber.toString().padStart(2, "0");
              yourBillingDate.innerHTML = `${day}/${month}/${year}`;
            } else {
              yourBillingDate.innerHTML = `${formattedBillingDate}`;
            }
          }
          return true;
        }
        return false;
      };

      setTimeout(() => {
        handleDeliveryDateUI();
      }, 1);
    }
    checkSkippedAttribute();
  });
}

//if awtomic subs list / my subscriptions
if (/^\/tools\/bundle-subscriptions\/?$/.test(location.pathname) && !location.search) {
  document.body.classList.add("awt-my-subs");
}

//if awtomic bab purchase flow
if (window.location.pathname.includes("/tools/bundle-subscriptions/bundle/")) {
  window.Awtomic = window.Awtomic || {};
  window.Awtomic.getBabSelection = () => {
    //babProductId is in a class of an element, the element is div.bundle-container.pv_xxxxxxx where xxxxxxx is the bab product id
    const babProductId = document
      .querySelector(".bundle-container")
      ?.className.split(" ")
      .find((c) => c.startsWith("pv_"))
      ?.split("_")[1];
    if (!babProductId) return {};

    const bundleProductCards = document.querySelectorAll(".bundle-product-card");

    const bundleSelectedProducts = {};
    bundleProductCards.forEach((card) => {
      const productId = card.getAttribute("data-pid");
      const quantityElement = card.querySelector(".bundle-product-card__quantity-button-container > span");
      const quantity = quantityElement ? parseInt(quantityElement.innerHTML) : 0;

      if (productId && quantity > 0) {
        bundleSelectedProducts[productId] = quantity;
      }
    });

    return { [babProductId]: bundleSelectedProducts };
  };

  waitForElement(".awtomatic-plans-container", (plansContainer) => {
    if (plansContainer.children.length <= 1) {
      document.body.classList.add("awt-single-frequency");
    }
  });

  //add "is-transparent-mode" to #header
  waitForElement("#header", (header) => header.classList.add("is-transparent-mode"), 0, 10000);

  //get .bundle-container and every time it scrolls if its scrolled remove is-transparent-mode from header
  waitForElement(".bundle-container", (bundleContainer) => {
    const header = document.querySelector("#header");
    if (!header) return;

    const onScroll = () => {
      if (bundleContainer.scrollTop > 0) {
        header.classList.remove("is-transparent-mode");
      } else {
        header.classList.add("is-transparent-mode");
      }
    };

    bundleContainer.addEventListener("scroll", onScroll);
    onScroll();
  });
}

//if localStorage openCart flag is set, click cart button and remove flag
if (localStorage.getItem("openCart")) {
  localStorage.removeItem("openCart");
  waitForElement(".l-header__controls-cart", (cartButton) => cartButton.click(), 0, 10000);
}

//cart rollup
document.body.addEventListener("click", async (event) => {
  if (!event.target.matches(".cart__remove-bundle *, .cart__remove-bundle[data-bundle-id]")) return;

  const bundleElement = event.target.closest(".cart__remove-bundle") || (event.target.hasAttribute("data-bundle-id") ? event.target : null);
  const bundle_id = bundleElement ? bundleElement.getAttribute("data-bundle-id") : null;

  if (bundle_id) {
    event.preventDefault();
    try {
      // Get current cart contents
      const cart = await (await fetch("/cart.js")).json();

      // Create data object for cart update AJAX call
      const data = {
        updates: cart.items.reduce((acc, item) => (item.properties?._bundleUid == bundle_id ? { ...acc, [item.key]: 0 } : acc), {})
      };

      // API call to update the cart contents and set the bundle item quantities to 0
      const response = await fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data)
      });

      response.ok && (window.location.href = "/cart");
    } catch (error) {
      console.error(error);
    }
  }
});
